export default {
  "content": "<g clip-path=\"url(#a)\" fill=\"#fff\"><path d=\"M15 12.5H1a.501.501 0 01-.5-.5V1C.5.725.725.5 1 .5h14c.275 0 .5.225.5.5v11c0 .275-.225.5-.5.5zm-13.5-1h13v-10h-13v10zm9.5 3H5a.501.501 0 01-.5-.5c0-.275.225-.5.5-.5h6c.275 0 .5.225.5.5s-.225.5-.5.5z\"/><path d=\"M4.5 9.5A.501.501 0 014 9V5.5c0-.275.225-.5.5-.5s.5.225.5.5V9c0 .275-.225.5-.5.5zm7 0A.501.501 0 0111 9V4c0-.275.225-.5.5-.5s.5.225.5.5v5c0 .275-.225.5-.5.5zM8 9.5a.501.501 0 01-.5-.5V7c0-.275.225-.5.5-.5s.5.225.5.5v2c0 .275-.225.5-.5.5z\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" transform=\"translate(.5 .5)\" d=\"M0 0h15v14H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 -6.5 16 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};